import { ref, computed, watch } from '@vue/composition-api'
// import { title } from '@core/utils/filter'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import router from '@/router'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList(props = nu) {
  const refListTable = ref(null)

  const toast = useToast()

  store.dispatch('master_tenant/getAll')

  const masterTenantOptions = computed(() => store.getters['master_tenant/getSelectedItems'])
  const masterTenantFilter = ref(null)

  if (router.currentRoute.params.id_master_tenant)
    masterTenantFilter.value = parseInt(router.currentRoute.params.id_master_tenant)

  let tableColumns = [
    { label: 'id', key: 'id', sortable: false },
    { label: 'tenants.main_image', key: 'image', sortable: false },
    { label: 'tenants.logo_image', key: 'logo_image', sortable: false },
    { label: 'tenants.image_mobile_app', key: 'app_image', sortable: false },
    { label: 'tenants.title', key: 'name', sortable: true },
    { label: 'Description', key: 'description', sortable: true },
    { label: 'master_tenants.title', key: 'master_tenant.name', sortable: true },
    { label: 'tenants.number_of_routers', key: 'routers_count', sortable: true },
    {
      label: 'date.created_at', key: 'created', sortable: true, formatter: 'formatDateAssigned',
    },
    {
      label: 'date.updated_at', key: 'updated', sortable: true, formatter: 'formatDateAssigned',
    },
  ]

  if (props.showFilters) {
    tableColumns = [{ label: 'actions.name', key: 'actions' }].concat(tableColumns);
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {

    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('tenant/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_master_tenant: masterTenantFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage,], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const applyChartFilters = (filters) => {
    if (filters) {
      searchQuery.value = filters['tenants.name'] && filters['tenants.name'].length ? filters['tenants.name'][0] : null;
      masterTenantFilter.value = filters['id_master_tenant'] || null;
    }
  }

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      id_master_tenant: masterTenantFilter.value
    };
    refetchData();
  }
  const clearSearchFilters = () => {
    masterTenantFilter.value = null;
    buildFilters();
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,

    masterTenantOptions,
    masterTenantFilter,

    refetchData,
    applyChartFilters,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
